/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fileExl': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M827.2 961.7H195.9c-49.6 0-90.2-36.7-90.2-81.6V145.8c0-44.9 40.6-81.6 90.2-81.6h496l225.4 224.4v591.5c0 44.9-40.5 81.6-90.1 81.6zM669.4 105h-22.5v204h225.4L669.4 105zm202.9 244.8H646.8c-24.8 0-45.1-18.4-45.1-40.8V105H195.9c-24.8 0-45.1 18.4-45.1 40.8v734.3c0 22.4 20.3 40.8 45.1 40.8h631.2c24.8 0 45.1-18.4 45.1-40.8V349.8zM619.7 591.3h40.7v121.9h66.9v27.2H619.7V591.3zM550 740.4l-31.1-48.6c-1.2-1.8-2.4-5.1-3.7-10h-.5c-.6 2.3-2 5.8-4.2 10.4l-31.2 48.1h-48.5l57.5-74.5-52.6-74.5h49.5L511 636c2 3.5 3.8 7.7 5.4 12.6h.5c1-2.9 2.9-7.2 5.7-13l28.7-44.3h45.3l-54.1 73.9 55.6 75.2H550zM308.4 591.3h104.1v27.3H349v33.2h59V679h-59v34.1h67.6v27.2H308.4v-149z" _fill="#FFF"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/fileExl.js